import React from 'react';  // eslint-disable-line

const LeftArrowCircle = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(8 8)" stroke="#FFF" strokeWidth="1.25" fill="none" fillRule="evenodd" strokeLinecap="round" opacity=".7" strokeLinejoin="round">
                <circle cx="7.5" cy="7.5" r="7.333" />
                <path d="M8.5 10.167L5.833 7.5 8.5 4.833" />
            </g>
        </svg>
    );
};

export default LeftArrowCircle;
